import React, { useContext, useEffect } from 'react'
import { PolymorphicProps } from '../helperTypes'
import Button from '../Button'
import { MenuContext } from './Menu'

export type MenuButtonProps<C extends React.ElementType> = PolymorphicProps<C, {}>

export const MenuButton = <C extends React.ElementType = typeof Button>(props: MenuButtonProps<C>) => {
  const { component, ...rest } = props
  const {
    state: { buttonFocused, buttonRef, menuId, open },
    dispatch,
  } = useContext(MenuContext)
  useEffect(() => {
    if (buttonFocused) {
      buttonRef!.current!.focus()
    }
  }, [buttonRef, buttonFocused])

  const ComponentProp = component || Button
  return (
    <ComponentProp
      aria-controls={open ? menuId : undefined}
      aria-haspopup='true'
      ref={buttonRef}
      tabIndex={0}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault()
        if (open) dispatch({ type: 'close', restoreFocus: true })
        else dispatch({ type: 'open', selectFirstItem: false })
      }}
      onFocus={() => {
        dispatch({ type: 'focusButton' })
      }}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (open) {
          return
        }
        const { code } = e.nativeEvent
        if (code === 'Enter' || code === 'Space' || code === 'ArrowDown' || code === 'ArrowUp') {
          e.preventDefault() // prevent scroll
          dispatch({ type: 'open', selectFirstItem: true })
        }
      }}
      {...rest}
    />
  )
}

export default MenuButton
